import ScrollReveal from 'scrollreveal'

document.addEventListener("DOMContentLoaded", function (event) {
	let doc = document;

	let header = doc.querySelector('header');
	let scrollToPriceButtons = doc.querySelectorAll('.scroll-to-price');
	if (scrollToPriceButtons[0]) {
		scrollToPriceButtons.forEach((button) => {
			button.addEventListener('click', (e) => {
				window.scrollTo({
					top: document.querySelector('.price-boxes').offsetTop - 100,
					behavior: 'smooth'
				});

				e.preventDefault();
			})
		})
	}


	const scrollTo = doc.querySelectorAll('.scroll-to');
	if (scrollTo[0]) {
		scrollTo.forEach((button) => {
			button.addEventListener('click', (e) => {
				const target = button.getAttribute('data-target');
				window.scrollTo({
					top: document.querySelector(target).offsetTop - 100,
					behavior: 'smooth'
				});

				e.preventDefault();
			})
		})
	}

	doc.addEventListener('mousemove', function (e) {
		if (doc.querySelector('.circles')) {
			let n = doc.querySelector('.landing-view').clientHeight;
			let a = (window.innerWidth / 2 - e.clientX) / 80,
				s = (e.clientY - n / 2) / 60;

			doc.querySelector('.circles').setAttribute('style', "transform: translate3d(" + a + "px," + s + "px,0px) scale3d(1.001,1.001,1.001)");
			doc.querySelector('.ilustration').setAttribute('style', "transform: translate3d(" + a * -1.2 + "px," + s * -0.8 + "px,0px) scale3d(1.001,1.001,1.001)");
		}
	});

	ScrollReveal().reveal("[data-animation-ref]", {
		origin: "bottom",
		distance: "25px",
		duration: 1e3,
		delay: 100,
		scale: 1,
		opacity: 0,
		easing: "ease-out",
		viewOffset: {
			bottom: 200
		}
	});

	let animateCalculate = false;

	let calculate = document.querySelectorAll('.calculate');
	const benefitsContent = document.querySelector('.benefits-content:not(.benefits-content--full)');
	let benefitsItems = document.querySelector('.benefits-items');


	let scroll = window.scrollY || document.documentElement.scrollTop;
	if (scroll > 0) {
		header.classList.add('scroll');
	} else {
		header.classList.remove('scroll');
	}

	window.addEventListener("scroll", function (e) {
		let scroll = this.scrollY || document.documentElement.scrollTop;
		// Animation calculating

		if (calculate.length > 0) {
			if (scroll >= calculate[0].getBoundingClientRect().top + window.innerHeight - 500 && !animateCalculate) {
				animateCalculate = true;
				for (let i = 0; i < calculate.length; i++) {
					let symbolAfter = calculate[i].getAttribute('data-symbol-after') || '';
					let symbolBefore = calculate[i].getAttribute('data-symbol-before') || '';
					let from = calculate[i].getAttribute('data-from');
					let to = calculate[i].getAttribute('data-to');
					let type = calculate[i].getAttribute('data-type');

					calculate[i].innerHTML = symbolBefore + from + symbolAfter;
					if (type !== 'time') {
						for (let k = from; k <= to; k++) {
							setTimeout(() => {
								calculate[i].innerHTML = symbolBefore + k + symbolAfter;
							}, (k / to) * 1200)
						}
					} else {
						for (let k = from; k <= to; k++) {
							setTimeout(() => {
								let sec_num = parseInt(k, 10);
								let hours = Math.floor(sec_num / 3600);
								let minutes = Math.floor((sec_num - (hours * 3600)) / 60);
								let seconds = sec_num - (hours * 3600) - (minutes * 60);
								if (hours < 10) {
									hours = "0" + hours;
								}
								if (minutes < 10) {
									minutes = "0" + minutes;
								}
								if (seconds < 10) {
									seconds = "0" + seconds;
								}
								calculate[i].innerHTML = hours + ':' + minutes + ':' + seconds;
							}, (k / to) * 1200)
						}
					}
				}
			}
		}

		if (benefitsContent) {
			const benefits = benefitsContent.querySelector('.benefits-wrap');
			if (scroll >= benefits.getBoundingClientRect().top - (window.innerHeight / 2)) {
				let margin = (benefits.getBoundingClientRect().top - benefitsItems.clientHeight / 2) * 1.7;
				if ((margin * -1) + 500 < benefitsItems.clientHeight && margin < 0) {
					benefitsItems.style.marginTop = margin + 'px'
				}
			}
		}

		if (scroll > 0) {
			header.classList.add('scroll');
		} else {
			header.classList.remove('scroll');
		}
	});
});
